import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import ModuleView from './Components/ModuleView';
import { withRouter } from 'react-router-dom';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../redux/reducers/savedVersions';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';


import { selectedContentItem, getAllThinkTools, getAllThinkToolsAndJournals, getContentModules } from '../redux/selectors';
import ContentView from './Components/ContentView';

import {
  getUserProgramsFullRequest,
} from '../redux/reducers/userProgramsFull';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { contentListRequest } from '../redux/reducers/contentList';
import { modulesListRequest } from '../redux/reducers/modulesList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Content = ({ view }) => <ContentView />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  content: state.contentListReducer.content,
  contentReducer: state.contentListReducer,
  getAllThinkToolsAndJournals: getAllThinkToolsAndJournals(state),
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  getContentForModule: () => dispatch(contentListRequest()),
  getModulesForProgram: () => dispatch(modulesListRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        toggleRefererPage,
        userProgramsFull,
        getAllThinkToolsAndJournals
      } = this.props;
      
     
      // this.props.getModulesForProgram()
      // this.props.getContentForModule();
    },
    componentWillReceiveProps(nextProps) {
      const { loginReducer, getClientBackGroundRequest, view } = nextProps;

      
    },
  }),
 
)(Content);

Content.propTypes = {
  view: PropTypes.instanceOf(Object),
};
